import { useTranslation } from 'react-i18next';
import React from 'react';
import DisplayView from './DisplayView';
import ReturnArrow from './buttons/ReturnArrow';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @Description Header with title, list or card view icon, additional header elements, and content aligned to the right for button components or others.
 * @param String name: section name (required).
 * @param {JSX.Element} children: Elements that will be the content of the component (required).
 * @param useState view: value of state (optional).
 * @param useState setView: value update state (optional).
 * @param String link: navigation url (optional).
 * @param event onBack: event click (required).
 * @param Boolean hidden: If true, it does not show the 'arrow left' icon (optional).
 * @param {JSX.Element} divStack: Elements that will be the header content of the component (required).
 * @param ReactComponent Icon  IconBack: The IconBack variable makes the back icon dynamic (optional).
 */
const HeadTittle = (props) => {
    const { name, children, view, setView, link = '', onBack, hidden = false, divStack = null, IconBack } = props;
    const { t } = useTranslation();

    return (
        <div className={`head h-auto flex-wrap`}>
            <div className="headLeft flex-wrap">
                {!hidden && (link || onBack) && (
                    <ReturnArrow link={link} onBack={onBack} IconBack={IconBack} />
                )}
                <p className={"fs-32px ibl-font-w-600 font-color-primary-800"}>{t(name)}</p>
                {view && setView && <DisplayView view={view} setView={setView} />}
                {divStack && (
                    <div className="d-flex flex-wrap">
                        {divStack}
                    </div>
                )}
            </div>
            <div className={'container-top-right-btns flex-wrap'}>
                {children}
            </div>
        </div>
    );
};

export default HeadTittle;
